import type { ID } from '@webrtc/lib/identifier'
import * as icons from '../Icons'
import { Button } from './Button'

export function ShareButton({ id }: { id: ID }) {
  const url = `${process.env.NEXT_PUBLIC_DOMAIN}/room/${id}`
  const title = `The meeting ${id}`

  const share = () => {
    const nav = navigator as any
    if (nav.share) {
      nav.share({ title: title, url })
    } else {
      navigator.clipboard.writeText(url)
    }
  }

  return <Button onClick={share}>{icons.Share(32)}</Button>
}
